import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import { safeParse } from "@/utils/safeParse";
import { useMemoizedFn, useMount } from "ahooks";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { create } from "zustand";

export const SIDE_NAV_COLLAPSED_KEY = "side_nav_collapsed";

export function getSideNavCollapsedState(req) {
  if (typeof window === "undefined") {
    // 服务器端
    return safeParse(req?.cookies?.[SIDE_NAV_COLLAPSED_KEY], () => true);
  }
  // 客户端
  return safeParse(Cookies.get(SIDE_NAV_COLLAPSED_KEY), () => true);
}

// 创建一个共享的 store
export const useSideNavStore = create((set) => ({
  isCollapsed: getSideNavCollapsedState(),
  setIsCollapsed: (value) => {
    Cookies.set(SIDE_NAV_COLLAPSED_KEY, value, { expires: 365 }); // 1年过期
    set({ isCollapsed: value });
  },
}));

export default function useSideNavCollapse() {
  const serverSideCollapsed = useAppStore((state) => state.isSideNavCollapsed);
  const { isCollapsed, setIsCollapsed } = useSideNavStore();

  // 初始化状态
  useMount(() => {
    const cookieValue = safeParse(
      Cookies.get(SIDE_NAV_COLLAPSED_KEY),
      () => serverSideCollapsed ?? true
    );
    useSideNavStore.setState({ isCollapsed: cookieValue });
  }); // 只在组件挂载时执行一次

  useEffect(() => {
    useAppStore.setState({ isSideNavCollapsed: isCollapsed });
  }, [isCollapsed]);

  const setSideNavCollapsed = useMemoizedFn((value) => {
    setIsCollapsed(value);

    // 触发事件，通知瀑布流重排（同步执行，优化更快）
    window.dispatchEvent(
      new CustomEvent(EVENT.SIDBAR_COLLAPSED, { detail: value })
    );
  });

  return [isCollapsed, setSideNavCollapsed];
}
